export default {
  'completeprofile.completeprofile': 'プロファイルプロセスを完成させてください',
  'completeprofile.maintext':
    'プロフィールアイテムを完成させてプラスのポイントを獲得するには、[プロフィールの完成]を押しプロフィールを完成させてください',
};
